export default {
  NODE_ENV: `${process.env.NODE_ENV}`,
  SDK_API_URL: `${process.env.SDK_API_URL}`,
  ROLLBAR_ACCESS_TOKEN: `${process.env.ROLLBAR_ACCESS_TOKEN}`,
  ROLLBAR_ENABLE: `${process.env.ROLLBAR_ENABLE}`,
  COMMIT_HASH: `${process.env.COMMIT_HASH}`,
  PUBNUB_SUB_KEY: `${process.env.PUBNUB_SUB_KEY}`,
  VERSION: `${process.env.VERSION}`,
  HELP_CENTER_URL: `${process.env.HELP_CENTER_URL}`,
  TERMS_URL: `${process.env.TERMS_URL}`,
  TABLELIST_WEBSITE_URL: `${process.env.TABLELIST_WEBSITE_URL}`,
  WIDGET_BASE_URL: `${process.env.WIDGET_BASE_URL}`,
  FAST_PASS_URL: `${process.env.FAST_PASS_URL}`,
  SEGMENT_WRITE_KEY: `${process.env.SEGMENT_WRITE_KEY}`,
  STRIPE_PUBLIC_KEY: `${process.env.STRIPE_PUBLIC_KEY}`,
  IMGIX_DOMAIN: `${process.env.IMGIX_DOMAIN}`,
  FILE_PICKER_API_KEY: `${process.env.FILE_PICKER_API_KEY}`,
  STRIPE_CLIENT_ID: `${process.env.STRIPE_CLIENT_ID}`,
  TL_API_KEY: `${process.env.TL_API_KEY}`,
  BRAZE_API_KEY: `${process.env.BRAZE_API_KEY}`
};



// WEBPACK FOOTER //
// ./src/config.js